import React from "react";
import { InputText, Label } from "../../../../components/Inputs";
import { validateAreaCode } from "../../../../components/Utils";

const AddressForm = React.forwardRef(function AddressForm(
  {
    className = "",
    model = {
      name: "",
      address: {
        street: "",
        houseNumber: "",
        areaCode: "",
        city: "",
      },
    },
    isVertical,
    address: propAddress,
    resetState,
    disabled,
    hideName,
    namePrefix = "",
  },
  ref,
) {
  const getState = (props) => {
    const { model } = props;
    const address = model.address || {};
    return {
      name: model.name || "",
      street: address.street || "",
      houseNumber: address.houseNumber || "",
      areaCode: address.areaCode || "",
      city: address.city || "",
      error: {
        name: null,
        street: null,
        houseNumber: null,
        areaCode: null,
        city: null,
      },
    };
  };

  const [state, setState] = React.useState(() => getState({ model }));

  // replica of componentWillReceiveProps: only resyncs when resetState is set
  React.useEffect(() => {
    if (!resetState) return;
    setState(getState({ model }));
  }, [resetState, model]);

  const validate = () => {
    const { error, ...model } = state;
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(model).forEach((key) => {
      if (newError[key] !== undefined && model[key] === "") {
        newError[key] = true;
        isValid = false;
      }
    });
    if (!validateAreaCode(model.areaCode)) {
      isValid = false;
      newError.areaCode = true;
    }
    if (!isValid) {
      setState((prev) => ({ ...prev, error: newError }));
      return null;
    }
    const { name, ...address } = model;
    return {
      name,
      address: { ...propAddress, ...address },
    };
  };

  React.useImperativeHandle(ref, () => ({
    getModel: () => validate(),
  }));

  const renderStreetHouse = (className) => {
    const { street, houseNumber, error } = state;
    return (
      <div
        className={`${className} ${
          error.street || error.houseNumber ? " error-group-" : ""
        }`}
      >
        <Label
          className="display-inline-block"
          htmlFor={`${namePrefix}address_form_street`}
        >{`Straße`}</Label>
        <Label className="display-inline-block">{`/`}</Label>
        <Label
          className="display-inline-block"
          htmlFor={`${namePrefix}address_form_housenumber`}
        >{`Hausnummer`}</Label>
        <div className="w3-row">
          <div className="w3-col s8 pad-sm-rht">
            <InputText
              id={`${namePrefix}address_form_street`}
              data-test-id={`${namePrefix}address_form_street`}
              className={`w3-block w3-border ${
                error.street ? "w3-border-red" : ""
              }`}
              value={street}
              onChange={(event) => {
                const value = event.target.value;
                setState((prev) => ({ ...prev, street: value }));
              }}
              disabled={disabled}
            />
          </div>
          <div className="w3-col s4 pad-sm-lft">
            <InputText
              id={`${namePrefix}address_form_housenumber`}
              data-test-id={`${namePrefix}address_form_housenumber`}
              className={`w3-block w3-border ${
                error.houseNumber ? "w3-border-red" : ""
              }`}
              value={houseNumber}
              onChange={(event) => {
                const value = event.target.value;
                setState((prev) => ({ ...prev, houseNumber: value }));
              }}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    );
  };
  const renderAreaCity = (className) => {
    const { areaCode, city, error } = state;
    return (
      <div
        className={`${className} ${
          error.areaCode || error.city ? " error-group-" : ""
        }`}
      >
        <Label
          className="display-inline-block"
          htmlFor={`${namePrefix}area_code`}
        >{`PLZ`}</Label>
        <Label className="display-inline-block">{`/`}</Label>
        <Label
          className="display-inline-block"
          htmlFor={`${namePrefix}city`}
        >{`Ort`}</Label>
        <div className="w3-row">
          <div className="w3-col s4 pad-sm-rht">
            <InputText
              id={`${namePrefix}area_code`}
              data-test-id={`${namePrefix}address_form_area_code`}
              className={`w3-block w3-border ${
                error.areaCode ? "w3-border-red" : ""
              }`}
              value={areaCode}
              onChange={(event) => {
                const value = event.target.value;
                setState((prev) => ({ ...prev, areaCode: value }));
              }}
              disabled={disabled}
            />
          </div>
          <div className="w3-col s8 pad-sm-lft">
            <InputText
              id={`${namePrefix}city`}
              data-test-id={`${namePrefix}address_form_city`}
              className={`w3-block w3-border ${
                error.city ? "w3-border-red" : ""
              }`}
              value={city}
              onChange={(event) => {
                const value = event.target.value;
                setState((prev) => ({ ...prev, city: value }));
              }}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    );
  };

  const { name, error } = state;
  return (
    <div className={className}>
      {!hideName && (
        <div className="pad-top form-group-item">
          <Label htmlFor={`${namePrefix}name`}>{`Firmenname*`}</Label>
          <InputText
            id={`${namePrefix}name`}
            className={`w3-block w3-border ${
              error.name ? "w3-border-red" : ""
            }`}
            value={name}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, name: value }));
            }}
            disabled={disabled}
            data-test-id={`${namePrefix}address_form_name`}
          />
        </div>
      )}
      <div className="neg-margin-lr">
        <div className="w3-row">
          {renderStreetHouse(
            `w3-col ${isVertical ? "m12" : "m6"} pad-lr pad-top form-group-item`,
          )}
          {renderAreaCity(
            `w3-col ${isVertical ? "m12" : "m6"} pad-lr pad-top form-group-item`,
          )}
        </div>
      </div>
    </div>
  );
});

export default AddressForm;
